export const getUser = (state) => state.auth.user
export const getIsLoadingPrivate = (state) => state.auth.authInProgress
export const getIsAuth = (state) => state.auth.isAuth
